<template>
  <div class="qaqc-dl-test-view">
    <DataQualityScorecardTable
      :rows="scorecardRows"
      :summary="scorecardSummary"
      :dataset-label="datasetLabel"
      :group-by="groupBy"
    />
    <ValidationPassRateMatrixTable
      :rows="validationMatrixRows"
      :title="validationMatrixTitle"
      :description="validationMatrixDescription"
      :matrix-test-context="matrixTestContext"
      :dataset-label="datasetLabel"
    />
    <div class="qaqc-overview-distribution-section">
      <DistributionPlotsSection
        :plot-options="distributionPlotOptions"
        :selected-plot-id="selectedPlotId"
        :distribution-data="distributionData"
        :distribution-chip-nav-context="distributionChipNavContext"
        :qc-distribution-test-name="qcDistributionTestName"
        @update:selected-plot-id="$emit('update:selectedPlotId', $event)"
      />
    </div>
    <ConsistencyCheckSection
      :cross-test-rows="consistencyCrossTestRows"
      :ordering-rows="consistencyOrderingRows"
      :matrix-test-context="matrixTestContext"
    />
    <div class="qaqc-overview-distribution-section">
      <DlAuxDistributionSection
        section-title="Total Material Balance Error Distribution"
        :plot-options="dlMaterialBalancePlotOptions"
        :selected-plot-id="selectedMaterialBalancePlotId"
        :distribution-data="dlMaterialBalanceDistributionData"
        :distribution-chip-nav-context="distributionChipNavContext"
        :qc-distribution-test-name="qcDistributionTestName"
        :csv-file-name="materialBalanceCsvFileName"
        @update:selected-plot-id="$emit('update:selectedMaterialBalancePlotId', $event)"
      />
    </div>
    <EquilibriumPlotLinearitySection :rows="equilibriumPlotRows" :matrix-test-context="matrixTestContext" />
    <div class="qaqc-overview-distribution-section">
      <DlAuxDistributionSection
        section-title="Overall Feed Deviation Distribution"
        :section-note="feedDeviationNote"
        :plot-options="[]"
        :distribution-data="dlFeedDeviationData"
        :distribution-chip-nav-context="distributionChipNavContext"
        :qc-distribution-test-name="qcDistributionTestName"
        :csv-file-name="feedDeviationCsvFileName"
      />
    </div>
  </div>
</template>

<script>
import DataQualityScorecardTable from "./DataQualityScorecardTable.vue";
import ValidationPassRateMatrixTable from "./ValidationPassRateMatrixTable.vue";
import ConsistencyCheckSection from "./ConsistencyCheckSection.vue";
import EquilibriumPlotLinearitySection from "./EquilibriumPlotLinearitySection.vue";
import DistributionPlotsSection from "./DistributionPlotsSection.vue";
import DlAuxDistributionSection from "./DlAuxDistributionSection.vue";

export default {
  name: "DLTestView",
  components: {
    DataQualityScorecardTable,
    ValidationPassRateMatrixTable,
    ConsistencyCheckSection,
    EquilibriumPlotLinearitySection,
    DistributionPlotsSection,
    DlAuxDistributionSection,
  },
  props: {
    scorecardRows: { type: Array, default: () => [] },
    scorecardSummary: {
      type: Object,
      default: () => ({
        overallPassRate: "0%",
        passedQc: 0,
        pendingQc: 0,
        failed: 0,
      }),
    },
    validationMatrixRows: { type: Array, default: () => [] },
    validationMatrixTitle: { type: String, default: "Validation Pass Rate Matrix" },
    validationMatrixDescription: { type: String, default: "Percentage of all DL samples passing each validation check" },
    datasetLabel: { type: String, default: "DL Dataset" },
    matrixTestContext: { type: String, default: "dl" },
    qcDistributionTestName: { type: String, default: "dltests" },
    materialBalanceCsvFileName: { type: String, default: "dl_material_balance_distribution.csv" },
    feedDeviationCsvFileName: { type: String, default: "dl_overall_feed_deviation.csv" },
    consistencyCrossTestRows: { type: Array, default: () => [] },
    consistencyOrderingRows: { type: Array, default: () => [] },
    equilibriumPlotRows: { type: Array, default: () => [] },
    distributionPlotOptions: { type: Array, default: () => [] },
    selectedPlotId: { type: String, default: "" },
    distributionChipNavContext: {
      type: String,
      default: "dl",
      validator: (v) => ["oil", "gas", "dl", "separator"].includes(v),
    },
    distributionData: { type: Object, default: () => ({}) },
    dlMaterialBalancePlotOptions: { type: Array, default: () => [] },
    selectedMaterialBalancePlotId: { type: String, default: "" },
    dlMaterialBalanceDistributionData: { type: Object, default: () => ({}) },
    dlFeedDeviationData: { type: Object, default: () => ({}) },
    feedDeviationNote: {
      type: String,
      default:
        "The deviation corresponds to the abs rel. error (%) between the reported original composition and the composition reconstructed from DL vapor-phase data via back-calculation of liquid moles.",
    },
    groupBy: { type: String, default: "well" },
  },
  emits: ["update:selectedPlotId", "update:selectedMaterialBalancePlotId"],
};
</script>
